import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
}

import { computed, onBeforeMount, ref, watch } from "vue";
import { CheckIcon, ChevronUpDownIcon, MagnifyingGlassIcon } from "@heroicons/vue/20/solid";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/vue";

interface SearchOption {
  id: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInputComponent',
  props: {
  context: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



// Computed property for the v-model value (the ID)
const modelValue = computed({
  get() {
    return props.context._value;
  },
  set(newValue) {
    props.context.node.input(newValue);
  },
});

// Computed property for search options
const searchOptions = computed<SearchOption[]>(
  () => props.context.searchOptions || []
);

const searchQuery = ref("");
let selectedOption = ref<SearchOption | null>(null);
let placeholder = ref<string>(
  props.context.placeholder || "Choose Your Option"
);

// Filtered search options based on the search query
const fiteredOptions = computed<SearchOption[]>(() =>
  searchQuery.value === ""
    ? searchOptions.value
    : searchOptions.value.filter((o) =>
        o.name.toLowerCase().includes(searchQuery.value.toLowerCase())
      )
);

// Watch the modelValue (the ID) and update the selected option when the ID changes
watch(modelValue, (newId) => {
  selectedOption.value =
    searchOptions.value.find((o) => o.id === newId) || null;
});

// Watch the selectedOption and update modelValue when it changes
watch(selectedOption, (newOption) => {
  if (newOption) {
    modelValue.value = newOption.id;
  }
});

// Initialize the selected option based on the initial model value
onBeforeMount(() => {
  const inputValue = props.context._value;
  selectedOption.value =
    searchOptions.value.find((o) => o.id == inputValue) || null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    as: "div",
    modelValue: _unref(selectedOption),
    "onUpdate:modelValue": [
      _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedOption) ? (selectedOption).value = $event : selectedOption = $event)),
      _cache[3] || (_cache[3] = ($event: any) => (searchQuery.value = ''))
    ]
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.context.showIcon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(MagnifyingGlassIcon), {
                class: "h-5 w-5 text-gray-400",
                "aria-hidden": "true"
              })
            ]))
          : _createCommentVNode("", true),
        _createVNode(_unref(ComboboxInput), {
          class: _normalizeClass([[
          props.context.showIcon ? 'pl-10' : 'pl-3',
          'w-full rounded-md border-0 bg-white py-2.5 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6'
        ], ""]),
          placeholder: _unref(placeholder),
          onChange: _cache[0] || (_cache[0] = ($event: any) => (searchQuery.value = $event.target.value)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (searchQuery.value = '')),
          "display-value": (option) => (_unref(selectedOption) as SearchOption)?.name
        }, null, 8, ["class", "placeholder", "display-value"]),
        _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
          default: _withCtx(() => [
            _createVNode(_unref(ChevronUpDownIcon), {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ]),
          _: 1
        }),
        (fiteredOptions.value.length > 0)
          ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
              key: 1,
              class: "absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fiteredOptions.value, (option) => {
                  return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                    key: option.id,
                    value: option,
                    as: "template"
                  }, {
                    default: _withCtx(({ active, selected }) => [
                      _createElementVNode("li", {
                        class: _normalizeClass([
              'relative cursor-default select-none py-2 pl-8 pr-4',
              active ? 'bg-blue-600 text-white' : 'text-gray-900',
            ])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['block truncate', selected && 'font-semibold'])
                        }, _toDisplayString(option.name), 3),
                        selected
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: _normalizeClass([
                'absolute inset-y-0 left-0 flex items-center pl-1.5',
                active ? 'text-white' : 'text-blue-600',
              ])
                            }, [
                              _createVNode(_unref(CheckIcon), {
                                class: "h-5 w-5",
                                "aria-hidden": "true"
                              })
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})